import React, { useState } from 'react'
import { ITestTrack, IPaper, ITestEventAssignedPapers, ITestEvent, ICandidateRegistration } from 'interfaces'
import {
  Button,
  Form,
  Modal,
  ModalProps,
  Popconfirm,
  Radio,
  RadioChangeEvent,
  Select,
  Space,
  Typography,
  useForm,
  Row,
  Col,
  Divider,
  Icons,
  Tag,
  DateField,
  Table,
  notification,
} from '@pankod/refine-antd'
import dayjs from 'dayjs'
import { useUpdateMany } from '@pankod/refine-core'

type Props = {
  candidateList: ICandidateRegistration[] | undefined
  testTrackList: ITestTrack[] | undefined
  testEvent: ITestEvent | undefined
  newPapers: IPaper[] | undefined
  oldPapers: ITestEventAssignedPapers[] | undefined
  modalProps: ModalProps
  close: any
}

const { SendOutlined, CheckCircleOutlined, CloseCircleOutlined } = Icons

const { Text } = Typography

const AssignPaperToCandidates: React.FC<Props> = ({ candidateList, testEvent, modalProps, close, newPapers, oldPapers, testTrackList }) => {
  console.log('THESE', newPapers, oldPapers, testTrackList)
  const { mutateAsync: updateRegistrations } = useUpdateMany<ICandidateRegistration>()

  const [isPaperApproved, setIsPaperApproved] = useState<boolean | undefined>(undefined)
  const [currenTrack, setCurrentTrack] = useState<string>()
  const [allPaperIds, setAllPaperIds] = useState<any>()
  const [selectedPaper, setSelectedPaper] = useState<IPaper | undefined>()
  const [oldPaperList, setOldPaperList] = useState<ITestEventAssignedPapers[] | undefined>(oldPapers)
  const [newPaperList, setNewPaperList] = useState<IPaper[] | undefined>(newPapers)
  const [paperListShow, setPaperListShow] = useState<string>('new_papers')
  const [validateLoading, setValidateLoading] = useState<boolean>(false)
  const [updateList, setUpdateList] = useState<ICandidateRegistration[]>()
  const [conflictingCandidateList, setConflictingCandidateList] = useState<ICandidateRegistration[]>()
  const { formProps, form } = useForm()

  // console.log('TODAY', dayjs('2023-05-19T18:42:31+0000').format('HH-mm'))
  // console.log('TODAY NOW', dayjs().format('HH-mm'))

  const handleSave = async () => {
    const allIds = updateList?.map(registration => registration?.id)
    await updateRegistrations(
      { resource: 'candidate_registration', ids: allIds ? allIds : [], values: { paper_id: selectedPaper?.id } },
      {
        onSuccess(data, variables, context) {
          notification.success({ message: 'Successful', description: `${allIds?.length} registrations updated.` })
          close()
        },
        onError(error, variables, context) {
          notification.error({ message: 'Something went wrong.', description: 'paper could not be assigned' })
        },
      }
    )
  }

  const handleSlot = (): boolean | undefined => {
    const testTrackId = form?.getFieldValue('test_track_id')
    console.log('receiving testtrackid', testTrackId)
    if (testTrackId && testTrackId?.length > 0) {
      return false
    }
    return true
  }

  const onCandidateCompatibleCheck = (candidateList: ICandidateRegistration[] | undefined) => {
    const testTrackId = form?.getFieldValue('')
    const selectedSlot = JSON.parse(form?.getFieldValue('slots'))
    let candidateWithConflictingPapers: ICandidateRegistration[] = []
    const compatibleCandidatesList = candidateList?.filter(candidate => {
      let hasPaperAssigned = !!candidate?.paper_id
      let hasAppearedBefore = false
      if (candidate?.test_track_id === testTrackId && !!!candidate?.paper_id) {
        const sameDate = dayjs(selectedSlot?.date).format('YYYY-MM-DD') === dayjs(candidate?.date).format('YYYY-MM-DD')
        const sameStartTime = dayjs(selectedSlot?.start_time).format('YYYY-MM-DD') === dayjs(candidate?.start_time).format('HH-mm')
        const sameEndTime = dayjs(selectedSlot?.end_time).format('YYYY-MM-DD') === dayjs(candidate?.end_time).format('HH-mm')
        if (sameDate && sameStartTime && sameEndTime) {
          //candidate has same slot
          const listOfPapersAppeared = candidate?.candidate_details?.registrations?.map(registration => registration?.paper_id)
          for (let i = 0; i < listOfPapersAppeared?.length; i++) {
            if (allPaperIds?.includes(listOfPapersAppeared[i])) {
              hasAppearedBefore = true
              break
            }
          }
          if (hasAppearedBefore) candidateWithConflictingPapers.push(candidate)
          // hasAppearedBefore ? candidateWithConflictingPapers.push(candidate) : null
        }
      }
      if (!hasAppearedBefore && !hasPaperAssigned) {
        return candidate
      }
    })
    setUpdateList(compatibleCandidatesList)
    if (candidateWithConflictingPapers?.length > 0) {
      setConflictingCandidateList(candidateWithConflictingPapers)
    }
    setValidateLoading(false)
  }

  const onPaperChange = (id: string) => {
    const listOfAllPaperIds = []
    if (paperListShow === 'new_papers') {
      const paper = newPaperList?.filter(paper => paper?.id === id)[0]
      const parentId = paper?.parent_paper_id
      const variantIds = paper?.variant_papers?.map(paper => paper?.id)
      listOfAllPaperIds.push(parentId, paper?.id)
      if (!!variantIds) listOfAllPaperIds.push(...variantIds)

      setAllPaperIds(listOfAllPaperIds)
      setIsPaperApproved(paper?.status === 'Approved')
      setSelectedPaper(paper)
    }
    if (paperListShow === 'old_papers') {
      const paper = oldPapers?.filter(paper => paper?.paper_id === id)[0]
      const parentId = paper?.paper?.parent_paper_id
      const variantIds = paper?.paper?.variant_papers?.map(paper => paper?.id)
      listOfAllPaperIds.push(parentId, paper?.id)
      if (!!variantIds) listOfAllPaperIds.push(...variantIds)

      setAllPaperIds(listOfAllPaperIds)
      setIsPaperApproved(true)
      setSelectedPaper(paper?.paper)
    }
  }

  const onRadioChange = (e: RadioChangeEvent) => {
    setPaperListShow(e.target.value)
    setIsPaperApproved(undefined)
    // form?.setFieldsValue({ new_papers: '', old_papers: '' })
    form?.setFields([
      { name: 'new_papers', value: '' },
      { name: 'old_papers', value: '' },
    ])
  }

  const onSlotChange = (slot: any) => {
    // const testTrackId = form?.getFieldValue('test_track_id')
    const testTrackId = currenTrack
    console.log('this TT here in slot change', testTrackId)
    const filteredNewPaperList = newPapers?.filter(paper => {
      const paperSlotData = paper?.slot_data
      const hasTestTrack = paper?.test_track_id === testTrackId
      const hasSlot = JSON.stringify(paperSlotData) === JSON.stringify(slot)
      return hasTestTrack && hasSlot
    })
    const filteredOldPaperList = oldPapers?.filter(paper => {
      const paperSlotData = paper?.slot_assigned
      const hasTestTrack = paper?.test_track_id === testTrackId
      const hasSlot = JSON.stringify(paperSlotData) === JSON.stringify(slot)
      return hasTestTrack && hasSlot
    })
    console.log('filterenewpaperlist', filteredNewPaperList)
    setOldPaperList(filteredOldPaperList)
    setNewPaperList(filteredNewPaperList)
  }

  const onTestTrackChange = (id: string) => {
    form?.setFieldsValue({ new_paper: '', old_paper: '' })
    // const newPaperListByTestTrack = newPapers?.filter(paper => paper?.test_track_id === id)
    // setNewPaperList(newPaperListByTestTrack)
    // const oldPaperListByTestTrack = oldPapers?.filter(assignedPaper => assignedPaper?.test_track_id === id)
    // setOldPaperList(oldPaperListByTestTrack)
    setCurrentTrack(id)
  }

  console.log('testTRACKK', form?.getFieldValue('test_track_id'))

  return (
    <Modal
      width={800}
      {...modalProps}
      title="Assign Paper To Candidates"
      afterClose={() => {
        form?.resetFields()
        setIsPaperApproved(undefined)
        setUpdateList([])
        setConflictingCandidateList([])
      }}
      footer={
        <Space>
          <Button
            onClick={() => {
              close()
            }}
          >
            Close
          </Button>
          {/* <Popconfirm title="Send request for a new paper creation ?" okText="Send Request">
            <Button icon={<SendOutlined />} color="green">
              Request Paper
            </Button>
          </Popconfirm> */}

          <Button
            type="primary"
            onClick={async () => {
              await handleSave()
            }}
          >
            Save
          </Button>
        </Space>
      }
    >
      <Form {...formProps} labelAlign="left" title="Assign Paper">
        <Row gutter={[16, 0]}>
          <Col sm={24} lg={12}>
            <Form.Item label="Test Track" required name="test_track_id">
              <Select placeholder="Select a Test Track" onChange={onTestTrackChange}>
                {testTrackList?.map((testTrack: ITestTrack, idx) => (
                  <option key={idx} value={testTrack?.id}>
                    {testTrack?.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col sm={24} lg={12}>
            <Form.Item label="Slot" name="slots" required>
              <Select placeholder="Pick a Slot" onChange={onSlotChange}>
                {testEvent?.slots?.map((slot: any) =>
                  slot?.test_track_id === currenTrack
                    ? slot?.list_of_slots?.map((data: any, idx: any) => (
                        <option key={idx} value={JSON.stringify(data)}>
                          <Space>
                            <Tag>
                              <DateField value={data?.date} format="LL" />
                            </Tag>
                            <Tag>
                              <Space>
                                <DateField value={data?.start_time} format="LT" />
                                <span>To</span>
                                <DateField value={data?.end_time} format="LT" />
                              </Space>
                            </Tag>
                          </Space>
                        </option>
                      ))
                    : null
                )}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Divider />

        <Radio.Group onChange={onRadioChange} defaultValue="new_papers" style={{ marginBottom: 30 }}>
          <Radio.Button key="new_papers" value="new_papers">
            Papers created from this Test Event
          </Radio.Button>
          <Radio.Button key="old_papers" value="old_papers">
            Papers created from other Test Events
          </Radio.Button>
        </Radio.Group>
        <Row gutter={[16, 0]}>
          {paperListShow === 'new_papers' ? (
            <Col sm={24} lg={12}>
              <Form.Item label="New Paper" name={'new_paper'} required={paperListShow === 'new_papers'}>
                <Select placeholder="Select a new paper" onChange={onPaperChange} disabled={!!!form?.getFieldValue('slots')}>
                  {newPaperList?.map((paper: IPaper, idx) => (
                    <option key={idx} value={paper?.id}>
                      #{paper?.paper_id} {paper?.paper_smart_id}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}

          {paperListShow === 'old_papers' ? (
            <Col sm={24} lg={12}>
              <Form.Item label="Old Paper" name={'old_paper'} required={paperListShow === 'old_papers'}>
                <Select placeholder="Select an old paper" onChange={onPaperChange} disabled={!!!form?.getFieldValue('slots')}>
                  {oldPaperList?.map((assignedPaper: ITestEventAssignedPapers, idx) => (
                    <option key={idx} value={assignedPaper?.paper_id}>
                      #{assignedPaper?.paper?.paper_id} {assignedPaper?.paper?.paper_smart_id}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {isPaperApproved !== undefined ? (
            <Col>
              <Tag color="success" icon={<CheckCircleOutlined />} visible={isPaperApproved}>
                Approved
              </Tag>
              <Tag color="error" icon={<CloseCircleOutlined />} visible={!isPaperApproved}>
                Not Approved
              </Tag>
            </Col>
          ) : null}
          {isPaperApproved ? (
            <Col>
              <Button
                loading={validateLoading}
                onClick={() => {
                  setValidateLoading(true)
                  onCandidateCompatibleCheck(candidateList)
                }}
              >
                Check Compatible Candidates
              </Button>
            </Col>
          ) : null}
        </Row>
      </Form>
      {updateList && updateList?.length > 0 ? <Text type="success">{updateList?.length} candidates are eligible for this paper.</Text> : null}
      {conflictingCandidateList && conflictingCandidateList?.length > 0 ? (
        <Text type="warning">
          {conflictingCandidateList?.length} candidates have already appeared for this paper/variant before. Assign or send request for a new paper.
        </Text>
      ) : null}
      {/* <Table dataSource={conflictingCandidateList}>
        <Table.Column></Table.Column>
      </Table> */}
    </Modal>
  )
}

export default AssignPaperToCandidates
